export default "__VITE_ASSET__66b2eca7__"